import { FacetsGroupsConfig } from '../../../models';
import { GETTERS_KEYS } from '../../store.const';
import { SEARCH_ACTIONS_KEYS, SEARCH_MUTATIONS_KEYS } from '../search.const';
import { SearchAction, SearchContext } from '../search.interfaces';

export class CloseFacetsPanelsAction implements SearchAction {
  actions = {
    [SEARCH_ACTIONS_KEYS.closeFacetsPanels]: ({ commit, state, rootGetters }: SearchContext) => {
      const facetsGroupsConfig: FacetsGroupsConfig = rootGetters[GETTERS_KEYS.config.facetsGroups];
      Object.keys(state.facetsGroups).forEach(panelId => {
        if (facetsGroupsConfig[panelId].collapsible) {
          commit(SEARCH_MUTATIONS_KEYS.setFacetsPanelCollapsed, { panelId: panelId, collapsed: true });
        }
      });
    }
  };
}
